export default ({ to, from } = {}) => {
  if (to && from) {
    return `${from} - ${to}`;
  }

  if (from && !to) {
    return `${from}`;
  }

  if (!from && to) {
    return `? - ${to}`;
  }

  return '?';
};
